import { useAnalyzerModules } from 'features/analyzerModules/api/getAnalyzerModules';
import { ModuleType } from 'features/analyzerModules/types';
import { useMemo } from 'react';
import { useAnalyzers } from '../api/getAnalyzers';

export const useGetAnalyzersByModule = (moduleType: ModuleType) => {
  const { data: analyzers } = useAnalyzers({});
  const { data: modules } = useAnalyzerModules({});
  return useMemo(
    () =>
      analyzers?.filter((analyzer) => {
        const associatedModules = modules?.find(
          (module) => module.analyzer_id === analyzer.id
        );
        if (!associatedModules) return false;
        return associatedModules.types.some((type) => type === moduleType);
      }),
    [analyzers, modules, moduleType]
  );
};
